import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router";
import "@/index.css";
import "@/i18n";
import Auth from "@/pages/Auth.tsx";
import EntrarComHandoff from "@/pages/EntrarComHandoff.tsx";
import Cadastro from "@/pages/Cadastro.tsx";
import PrivateRoutes from "@/utils/PrivateRoutes.tsx";
import Home from "@/pages/Home.tsx";
import { AppProvider } from "@/contexts/index.tsx";
import { ThemeProvider } from "@/components/ThemeProvider";
import Etiquetas from "@/pages/Etiquetas.tsx";
import EditorEtiqueta from "@/pages/EditorEtiqueta.tsx";
import LayoutPrincipal from "@/layout/LayoutPrincipal.tsx";
import NotFound from "./pages/NotFound";
import OrdensDeImpressao from "./pages/OrdensDeImpressao/OrdensDeImpressao";
import OrdensDeImpressaoVisualizar from "./pages/OrdensDeImpressao/OrdensDeImpressaoVisualizar";
import MinhaConta from "./pages/MinhaConta";
import Serializacao from "./pages/Serializacao";
import ImpressaoAvulsa from "./pages/ImpressaoAvulsa";
import GravacaoAvulsa from "./pages/GravacaoAvulsa";
import ImportarPlanilha from "./pages/ImportarPlanilha";
import ImportarXML from "./pages/ImportarXML";
// import ReimprimirEtiqueta from "./pages/ReimprimirEtiqueta";
import LogsDeImpressao from "./pages/LogsDeImpressao";
import ImportarOF from "./pages/ImportarOF";
import AjusteRoloAutomaticoSocket from "./pages/AjusteRoloAutomaticoSocket";
import ReimprimirEtiqueta from "./pages/ReimprimirEtiqueta";
import ImpressaoSSCC from "./pages/ImpressaoSSCC";
import ImpressaoPanvel from "./pages/Personalizados/ImpressaoPanvel";
import PerfilModulo from "./pages/PerfilModulo";
import Documentacao from "./pages/Documentacao";
import ConferirEtiqueta from "./pages/ConferirEtiqueta";
import FilaImpressaoSocket from "./pages/FilaImpressaoSocket";
import TestadorModulo from "./pages/TestadorModulo";

// Mapeia cada rota para a chave i18n do título exibido no cabeçalho.
// O texto traduzido é resolvido em SiteHeader via t(routeNames[pathname]).
export const routeNames: Record<string, string> = {
  "/auth": "routes.login",
  "/": "routes.inicio",
  "/etiquetas": "routes.etiquetas",
  "/etiquetas/editor": "routes.editorEtiqueta",
  "/conferir-etiqueta": "routes.conferirEtiqueta",
  "/importar-ordem": "routes.importarOrdem",
  "/importar-ordem/:nome_da_ordem": "routes.importarOrdem",
  "/impressao-avulsa": "routes.impressaoAvulsa",
  "/gravacao-avulsa": "routes.gravacaoAvulsa",
  "/reimprimir-etiqueta": "routes.reimprimirEtiqueta",
  "/importar-planilha": "routes.importarPlanilha",
  "/importar-xml": "routes.importarXml",
  "/logs-impressao": "routes.logsImpressao",
  "/fila-impressao-socket": "routes.filaImpressaoSocket",
  "/serializacao": "routes.serializacao",
  "/testador-modulo": "routes.testadorModulo",
  "/importar-of": "routes.importarPedidos",
  "/impressao-sscc": "routes.impressaoSscc",
  "/impressao-bipagem": "routes.impressaoBipagem",
  "/perfil-de-preferencia": "routes.perfilPreferencia",
  "/preferencias": "routes.preferencias",
  "/documetacao": "routes.documentacao",
};

const rootElement: any = document.getElementById("root");
if (!rootElement._reactRootContainer) {
  createRoot(document.getElementById("root")!).render(
    <ThemeProvider>
      <AppProvider>
        <BrowserRouter>
        <Routes>
          <Route element={<PrivateRoutes />}>
            <Route element={<LayoutPrincipal />}>
              <Route path="/" element={<Home />} />
              <Route path="/etiquetas" element={<Etiquetas />} />
              <Route path="/etiquetas/editor" element={<EditorEtiqueta />} />
              <Route path="/impressao-avulsa" element={<ImpressaoAvulsa />} />
              <Route path="/gravacao-avulsa" element={<GravacaoAvulsa />} />
              <Route path="/importar-planilha" element={<ImportarPlanilha />} />
              <Route path="/importar-xml" element={<ImportarXML />} />
              <Route path="/importar-ordem" element={<OrdensDeImpressao />} />
              <Route path="/conferir-etiqueta" element={<ConferirEtiqueta />} />
              <Route
                path="/importar-ordem/:nome_da_ordem"
                element={<OrdensDeImpressaoVisualizar />}
              />
              <Route path="/importar-pedidos" element={<ImportarOF />} />
              <Route path="/impressao-sscc" element={<ImpressaoSSCC />} />
              <Route
                path="/reimprimir-etiqueta"
                element={<ReimprimirEtiqueta />}
              />
              <Route path="/impressao-bipagem" element={<ImpressaoPanvel />} />
              <Route path="/logs-impressao" element={<LogsDeImpressao />} />
              <Route
                path="/fila-impressao-socket"
                element={<FilaImpressaoSocket />}
              />
              <Route path="/serializacao" element={<Serializacao />} />
              <Route path="/testador-modulo" element={<TestadorModulo />} />
              <Route path="/preferencias" element={<MinhaConta />} />
              <Route path="/perfil-de-preferencia" element={<PerfilModulo />} />
              <Route path="/documentacao" element={<Documentacao />} />
            </Route>
          </Route>
          <Route path="/auth" element={<Auth />} />
          {/* Passagem de sessão vinda de outro sistema da plataforma.
              Substitui /auth/:id_conta/:id_usuario, que reautenticava com a
              senha do usuário obtida por um bearer fixo do bundle público. */}
          <Route path="/entrar" element={<EntrarComHandoff />} />
          <Route path="/cadastro" element={<Cadastro />} />
          <Route
            element={<AjusteRoloAutomaticoSocket />}
            path="/ajuste-rolo-automatico-socket/:id_modulo"
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
        </BrowserRouter>
      </AppProvider>
    </ThemeProvider>,
  );
}
